// src/iframe.js
export function mountIframe(host, { src, config }) {
  const f = document.createElement('iframe');
  // Chat takes no payment — no allow="payment" and no allow-top-navigation needed.
  f.setAttribute('sandbox', 'allow-scripts allow-forms allow-same-origin');
  f.setAttribute('title', 'Chat');
  f.src = src;

  const targetOrigin = new URL(src).origin;
  const initMessage = {
    type: 'attraxion-chat:init',
    config,
    origin: window.location.origin,
  };

  const postInit = () => {
    try { f.contentWindow?.postMessage(initMessage, targetOrigin); } catch {}
  };

  // Fast path: post when the iframe document loads.
  f.addEventListener('load', postInit);

  // Race fallback: if React mounts after `load` fires, the EmbedShell's
  // message listener won't be attached yet and the init message will be lost.
  // The embed sends `attraxion-chat:ready` once its listener is up — re-post on that.
  window.addEventListener('message', (e) => {
    if (e.source === f.contentWindow && e.data?.type === 'attraxion-chat:ready') {
      postInit();
    }
  });

  host.appendChild(f);
  return f;
}
